export const memberProfile = {
  "verified": "Verificato",
  "online": "In linea",
  "memberSince": "Membro dal",
  "contact": "Contatta",
  "share": "Condividi",
  "respondsIn": "Risponde in",
  "responseRate": "di risposta",
  "exchangesCompleted": "Scambi realizzati",
  "reviews": "recensioni",
  "responseRateLabel": "Tasso di risposta",
  "memberSinceLabel": "Membro dal",
  "years": "anni",
  "year": "anno",
  "exchangeHistory": "Cronologia scambi",
  "property": "Alloggio",
  "reviewsTab": "Recensioni",
  "all": "Tutti",
  "completed": "Completati",
  "upcoming": "In arrivo",
  "cancelled": "Cancellato",
  "exchangeWith": "Scambio con",
  "nights": "notti",
  "noExchangeInCategory": "Nessuno scambio in questa categoria",
  "offeredProperty": "Alloggio proposto",
  "memberReviews": "Recensioni dei membri"
};
